import { render, staticRenderFns } from "./StudioTransfer.vue?vue&type=template&id=4b4babc1"
import script from "./StudioTransfer.vue?vue&type=script&lang=ts"
export * from "./StudioTransfer.vue?vue&type=script&lang=ts"
import style0 from "./StudioTransfer.vue?vue&type=style&index=0&id=4b4babc1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports